'use client';

import { useState, useEffect } from 'react';
import { getFirstTouchUTM, type FirstTouchUTM } from '@/lib/utm-tracker';

/**
 * Hook que retorna os dados de first-touch UTM do cookie
 * Usa useState + useEffect para evitar hydration mismatch
 */
export function useFirstTouchUTM(): FirstTouchUTM | null {
  const [utmData, setUtmData] = useState<FirstTouchUTM | null>(null);

  useEffect(() => {
    // Só ler cookie no client-side após hidratação
    const data = getFirstTouchUTM();
    setUtmData(data);
  }, []);

  return utmData;
}
